import { MapPin } from '@phosphor-icons/react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { advanceFlow, closeBirthChartFlow, getBirthChartFlow, patchFlowDetails } from '../../../../store/slices/birthChartSlice';
import { gaEvents } from '../../../../utils/analytics';
import AutocompliteInput from '../../../common/AutocompliteInput';
import Button, { BUTTON_STYLE_TYPE } from '../../../common/Button';
import Sheet from './Sheet';
import { firstMissingStep } from './flowLogic';
import styles from './styles.module.scss';

/**
 * The autocomplete reports a pick by writing `{ value: placeId, label }` into a
 * react-hook-form field (same as Profile v2 EditBirthPlace), so the selection
 * is read back with `watch`. `undefined` means "untouched" — keep the place the
 * flow already holds; `null` means the user cleared it.
 */
const PlaceSheet = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { details } = useSelector(getBirthChartFlow);

    const { control, setValue, watch } = useForm();
    const selected = watch('birthAddress');

    let place = details.place;
    if (selected === null) place = null;
    else if (selected?.value) place = { placeId: selected.value, description: selected.label };

    const handleContinue = () => {
        if (!place) return;
        dispatch(patchFlowDetails({ place }));
        gaEvents.bcStepCompleted('place');
        dispatch(advanceFlow(firstMissingStep({ ...details, place })));
    };

    return (
        <Sheet
            title={t('birthChart.flow.place.title')}
            onClose={() => dispatch(closeBirthChartFlow())}
            closeLabel={t('birthChart.flow.close')}
        >
            <div className={styles.placeField}>
                <AutocompliteInput
                    defaultValue={details.place}
                    control={control}
                    name="birthAddress"
                    setValue={setValue}
                    placeholder={t('birthChart.flow.place.placeholder')}
                    variant="profile-field"
                />
                <MapPin size={22} color="#ffffff" className={styles.placePin} aria-hidden="true" />
            </div>
            <Button
                styleType={BUTTON_STYLE_TYPE.PURPLE}
                extraClasses={[styles.cta]}
                text={t('birthChart.flow.continue')}
                onClick={handleContinue}
                disable={!place}
            />
        </Sheet>
    );
};

export default PlaceSheet;
